import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-01-maxon-lewis-guest.webp";
import ThumbImg from "../../assets/images/conversations/001.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";

/* ─────────────────────────────────────────────
   PREFIX: ml-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .ml-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .ml-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .ml-hero { padding-top: 60px; padding-bottom: 60px; }
  .ml-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .ml-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .ml-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ml-hero__title.ml-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .ml-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .ml-hero__social.ml-visible { opacity: 1; transform: translateY(0); }
  .ml-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 16.5px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .ml-hero__social a:hover { opacity: 0.85; }
  .ml-hero__social a.li { background: #0077B5; }
  .ml-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .ml-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .ml-hero__spotify.ml-visible { opacity: 1; transform: translateY(0); }
  .ml-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .ml-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .ml-hero__right.ml-visible { opacity: 1; transform: translateY(0); }

  .ml-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .ml-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .ml-yt-thumb:hover img { opacity: 0.85; }
  .ml-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .ml-yt-thumb__play img { width: 40px; height: 44px; }
  .ml-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .ml-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .ml-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ml-body.ml-visible { opacity: 1; transform: translateY(0); }
  .ml-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .ml-body__para:last-child { margin-bottom: 0; }

  .ml-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .ml-guest.ml-visible { opacity: 1; transform: translateY(0); }
  .ml-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .ml-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .ml-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .ml-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .ml-inner { padding-left: 32px; padding-right: 32px; }
    .ml-hero { padding-top: 32px; padding-bottom: 48px; }
    .ml-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .ml-hero__title { font-size: 24px; }
    .ml-hero__left { gap: 16px; }
    .ml-hero__social { gap: 10px; }
    .ml-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .ml-guest__title { font-size: 24px; margin-bottom: 24px; }
    .ml-guest__photo-bg { width: 260px; height: 300px; }
    .ml-guest__name { font-size: 24px; margin-top: 18px; }
    .ml-body__para { font-size: 14px; margin-bottom: 12px; }
    .ml-body { padding-bottom: 48px; }
    .ml-guest { padding-bottom: 48px; }
    .ml-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .ml-inner { padding-left: 16px; padding-right: 16px; }
    .ml-hero { padding-top: 51px; padding-bottom: 30px; }
    .ml-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .ml-hero__left { gap: 30px; }
    .ml-hero__title { font-size: 30px; }
    .ml-hero__social { gap: 11px; }
    .ml-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .ml-body__para { font-size: 16px; margin-bottom: 10px; }
    .ml-guest__title { font-size: 30px; margin-bottom: 20px; }
    .ml-guest__photo-bg { width: 100%; height: 386px; }
    .ml-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .ml-body { padding-bottom: 30px; }
    .ml-guest { padding-bottom: 30px; }
    .ml-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ml-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP01_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="ml-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 01 Maxon Lewis"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="ml-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 01 Maxon Lewis thumbnail" />
      <div className="ml-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="ml-hero">
      <div className="ml-inner">
        <div className="ml-hero__grid">
          <div className="ml-hero__left">
            <div ref={titleRef} className="ml-hero__title">
              EP 01 | Candid conversation with Maxon LEWIS, MD of Magenta Power on the road map to 100% E-Mobility in India
            </div>
            <div ref={socialRef} className="ml-hero__social">
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
            </div>
            <div ref={spotifyRef} className="ml-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/1VUecIBA3GZpFnqCUBzOWO?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 01 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="ml-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ml-body">
      <div className="ml-inner">
        <p className="ml-body__para">
          Maxson LEWIS is the Managing Director of Magenta Power, one of India's largest charge point operators. Magenta focuses on clean mobility &amp; clean energy. In this conversation, Maxson covers his journey establishing a start-up in India that is focused on clean mobility and offers deep insights into a possible road map for full electrification of the mobility sector in India. The conversation touches on the need for the entire EV ecosystem to move forward in a coordinated manner simultaneously, building trust with consumers and also the impact of the hydrogen economy on E-mobility in India.
        </p>
        <p className="ml-body__para">
          Tune in to the whole podcast to learn from one of India's largest charge point operators.
        </p>
        <p className="ml-body__para">
          Today we have a conversation with Maxson LEWIS, on the government policies for EVs in India, the future of hydrogen &amp; the 2030 dream of complete electrification.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="ml-guest">
      <div className="ml-inner">
        <h2 className="ml-guest__title">Our Guest</h2>
        <div>
          <div className="ml-guest__photo-bg">
            <img src={GuestImg} alt="Maxon Lewis" />
          </div>
          <p className="ml-guest__name">Maxon LEWIS</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep01MaxonLewis() {
  return (
    <>
      <style>{CSS}</style>
      <div className="ml-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}